import axios from '../../utils/axios';

export const getVideos = async (tags, search, author) => {
  let queryString = '';

  tags.map((tag) => {
    console.log(`tags_like=${tag}`);
  });
  if (tags?.length > 0) {
    queryString += tags.map((tag) => `tags_like=${tag}`).join('&');
  }

  if (search !== '') {
    queryString += `&q=${search}`;
  }
  if (author !== '') {
    queryString += `&q=${author}`;
  }

  const response = await axios.get(`/videos/?${queryString}`);

  return response.data;
};
